export const STEP_WAITING = 0;
export const STEP_IN_PROGRESS = 1;
export const STEP_OK = 2;
export const STEP_NOT_COMPLETE = 3;
export const STEP_NOT_DETECTED = 4;

export const LUBRICATION_TEXTS = {
  [STEP_WAITING]: 'En attente de lubrification',
  [STEP_IN_PROGRESS]: 'Lubrification en cours',
  [STEP_OK]: 'Lubrification correctement réalisée',
  [STEP_NOT_COMPLETE]: 'Lubrification incomplète',
  [STEP_NOT_DETECTED]: 'Pas de lubrification réalisée',
  [undefined]: 'En attente de lubrification',
  [null]: 'Aucune donnée de lubrification',
};

export const PIPES_TEXTS = {
  [STEP_WAITING]: 'En attente d\'emmanchement',
  [STEP_IN_PROGRESS]: 'Emmanchement en cours',
  [STEP_OK]: 'Emmanchement correctement réalisé',
  [STEP_NOT_COMPLETE]: 'Emmanchement incomplet',
  [STEP_NOT_DETECTED]: 'Pas d\'emmanchement réalisé',
  [undefined]: 'En attente d\'emmanchement',
  [null]: 'Aucune donnée d\'emmanchement',
};

export const CLIPS_TEXTS = {
  [STEP_WAITING]: 'En attente de clipsage',
  [STEP_IN_PROGRESS]: 'Clipsage en cours',
  [STEP_OK]: 'Clipsage correctement réalisé',
  [STEP_NOT_COMPLETE]: 'Clipsage incomplet',
  [STEP_NOT_DETECTED]: 'Pas de clipsage réalisé',
  [undefined]: 'En attente de clipsage',
  [null]: 'Aucune donnée de clipsage',
};

export const STEP_COLORS = {
  [STEP_WAITING]: 'bg-perception-gray-800',
  [STEP_IN_PROGRESS]: 'bg-perception-gray-800',
  [STEP_OK]: 'bg-green-500',
  [STEP_NOT_COMPLETE]: 'bg-orange-500',
  [STEP_NOT_DETECTED]: 'bg-red-500',
  [undefined]: 'bg-perception-gray-800',
  [null]: 'bg-perception-gray-800',
};

